import React from "react";

const InvoiceTypeDropdown = ({ reportType, onChange }) => {
  const invoiceOptions = [
    { value: 'enrolled', label: 'Students Enrolled' },
    { value: 'passed', label: 'Students Passed' },
    { value: 'placed', label: 'Student Placed' },
    { value:"assessed",label:"Student Assessed"},
    { value:"failed", label:"Student Failed"}

  ];

  return (
    <div>
      <label htmlFor="invoice-type" className="block text-gray-700 text-sm font-semibold mb-2">
       Status Type
      </label>
      <select
        id="invoice-type"
        name="invoiceType"
        value={reportType}
        onChange={onChange}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

      >
        <option value="">Students Report Type</option>
        {invoiceOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default InvoiceTypeDropdown;
